import Vue from 'vue'
import Router from 'vue-router'
import IndexMain from '@/components/Index'
import Rules from '@/components/Rules'
import News from '@/components/News'
import Help from '@/components/Help'
import NewsDetail from '@/components/NewsDetail'
import BannerDetail from '@/components/BannerDetail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'indexMain',
      title:'首页',
      component:IndexMain,
      // 到HelloWorld页面后直接跳转到indexmain页面
      // redirect: '/indexMain',
      meta: {
        authentication: true
      }
      //
    },
    {
      path: '/newsdetail',
      name: 'NewsDetail',
      component: NewsDetail
    },
	{
	  path: '/rules',
	  name: 'Rules',
	  component: Rules
	},
	{
	  path: '/news',
	  name: 'News',
	  component: News
	},
	{
	  path: '/help',
	  name: 'Help',
	  component: Help
	},
	{
	  path: '/bnDetail',
	  name: 'BannerDetail',
	  component: BannerDetail
	}
  ]
})
